import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import StatusDropButton from 'components/StatusDropButton/StatusDropButton';
import TextField from 'components/TextField/TextField';
import { SEARCH, STATUS } from 'constants/formFields';

import type IFilterBar from './interfaces/IFilterBar';

import styles from './scss/FilterBar.module.scss';

function FilterBar({
  control, onSearchChange, statusOption, onResetOffset,
}: IFilterBar) {
  const { t } = useTranslation();

  return (
    <div className={styles.filters}>
      <div className={styles.search}>
        <Controller
          control={control}
          name={SEARCH}
          render={({ field: { name, value, onChange }, fieldState: { error } }) => (
            <TextField
              name={name}
              value={value}
              placeholder={t('common.searchByName')}
              error={error?.message}
              icon={<SearchIcon />}
              onChange={(event) => {
                onChange(event.target.value);
                onSearchChange({ search: event.target.value, onChange });
              }}
              required
            />
          )}
        />
      </div>
      <div className={styles.filtersWrapper}>
        <div className={styles.filterTitleIcon}>
          <FilterIcon />
          <span>{t('common.filterBy')}</span>
        </div>
        <div className={styles.selectors}>
          <Controller
            control={control}
            name={STATUS}
            render={({ field: { value, onChange } }) => (
              <StatusDropButton
                options={statusOption}
                title={t('taskManagement.status')}
                selectedOptions={value?.filter((item): item is string => item !== undefined)}
                onSelectionChange={onChange}
                className={styles.buttonStatus}
                classNameList={styles.buttonStatusList}
                clearAllSelected={() => onChange([])}
                resetFunction={onResetOffset}
                translate
                hideSearch
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default FilterBar;
